<script setup>
  const props = defineProps(['channels']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <ul>
    <li v-for="channel in props.channels">
      <Button v-if="channel.link" :to="channel.link">
        <img :src="channel.logo" :alt="channel.title" width="120" height="54"
      /></Button>
      <Button v-else class="no-link"> <img :src="channel.logo" :alt="channel.title" width="120" height="54" /></Button>
      <h4>{{ channel.title }}</h4>
      <span v-if="channel.subtitle">{{ channel.subtitle }}</span>
    </li>
  </ul>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  ul {
    display: flex;
    flex-wrap: wrap;

    column-gap: px(24);
    row-gap: px(32);

    li {
      position: relative;

      width: 100%;
      max-width: calc(50% - px(12));

      flex: 1 0 40%;

      text-align: center;

      .no-link {
        pointer-events: none;
      }

      a {
        width: 100%;
        height: px(64);

        img {
          width: px(120);
          height: px(54);
        }
      }

      h4,
      span {
        display: block;

        @include industry-demi(px(12));
        color: $grey-1;
      }

      h4 {
        margin-top: px(4);
        text-align: center;
      }
      span {
        position: absolute;
        width: 100%;

        color: $black-5;
        margin-top: px(-1);
      }
    }

    @include break-large {
      column-gap: px(16);

      li {
        max-width: calc(50% - px(8));
        a {
          height: px(56);
        }
      }
    }

    @include break-medium {
      column-gap: px(12);
      li {
        max-width: calc(50% - px(6));
      }
    }

    @include break-small {
      column-gap: px(8);
      row-gap: px(28);

      li {
        max-width: calc(50% - px(4));

        a {
          height: px(52);
        }
      }
    }

    @include break-phone {
      column-gap: px(4);

      li {
        max-width: calc(50% - px(2));

        a {
          height: px(48);
        }
      }
    }
  }
</style>
